export default __webpack_public_path__ + "images/e4a343ecc1405d59b04181287454241d.svg";